var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { default as AntTimePicker } from 'antd/lib/time-picker';
import { range } from 'lodash';
import moment from 'moment';
import { globalConfig } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';

var TimeRangePicker = function (_super) {
  __extends(TimeRangePicker, _super);

  function TimeRangePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.endDisabledHours = _this.endDisabledHours.bind(_this);
    _this.endDisabledMinutes = _this.endDisabledMinutes.bind(_this);
    _this.endDisabledSeconds = _this.endDisabledSeconds.bind(_this);
    _this.startDisabledHours = _this.startDisabledHours.bind(_this);
    _this.startDisabledMinutes = _this.startDisabledMinutes.bind(_this);
    _this.startDisabledSeconds = _this.startDisabledSeconds.bind(_this);
    _this.format = props.format || globalConfig.get('format.timeRange') || '';
    _this.startString = '';
    _this.endString = '';
    return _this;
  }

  TimeRangePicker.prototype.onTimeChange = function (status, _time, timeString) {
    var _a, _b;

    var _c = this.props,
        onChange = _c.onChange,
        name = _c.name,
        limit = _c.range;

    if (status === 'start') {
      this.startString = timeString;
    } else if (status === 'end') {
      this.endString = timeString;
    }

    var defaultStart = ((_a = limit) === null || _a === void 0 ? void 0 : _a.start) || '00:00:00';
    var defaultEnd = ((_b = limit) === null || _b === void 0 ? void 0 : _b.end) || '23:59:59';

    if (onChange) {
      var timeRange = {
        start: this.startString || moment(defaultStart, 'HH:mm:ss').format(this.format),
        end: this.endString || moment(defaultEnd, 'HH:mm:ss').format(this.format)
      };
      onChange(timeRange, name);
    }
  };

  TimeRangePicker.prototype.startDisabledHours = function () {
    var _a;

    var _b = this.props,
        value = _b.value,
        limit = _b.range;
    var endTime;

    if (value) {
      endTime = value.end;
    }

    var startLimit = moment((_a = limit) === null || _a === void 0 ? void 0 : _a.start, this.format).hour() || 0;
    var endTimeHour = moment(endTime, this.format).hour();
    return endTime ? range(endTimeHour + 1, 24).concat(range(0, startLimit)) : range(0, startLimit);
  };

  TimeRangePicker.prototype.startDisabledMinutes = function (selectedHour) {
    var _a;

    var _b = this.props,
        value = _b.value,
        limit = _b.range;
    var endTime;

    if (value) {
      endTime = value.end;
    }

    var startLimit = moment((_a = limit) === null || _a === void 0 ? void 0 : _a.start, this.format);
    var end = moment(endTime, this.format);
    var disabledMinutes = [];

    if (selectedHour === end.hour()) {
      if (selectedHour === startLimit.hour()) {
        disabledMinutes = range(end.minute() + 1, 60).concat(range(0, startLimit.minute()));
      } else {
        disabledMinutes = range(end.minute() + 1, 60);
      }
    } else if (selectedHour === startLimit.hour()) {
      disabledMinutes = range(0, startLimit.minute());
    } else {
      disabledMinutes = [];
    }

    return disabledMinutes;
  };

  TimeRangePicker.prototype.startDisabledSeconds = function (selectedHour, selectedMinute) {
    var _a;

    var _b = this.props,
        value = _b.value,
        limit = _b.range;
    var endTime;

    if (value) {
      endTime = value.end;
    }

    var end = moment(endTime, this.format);
    var startLimit = moment((_a = limit) === null || _a === void 0 ? void 0 : _a.start, this.format);
    var disabledSeconds = [];

    if (selectedHour !== end.hour() && selectedHour !== startLimit.hour()) {
      disabledSeconds = [];
    } else if (selectedHour === end.hour() && selectedHour === startLimit.hour()) {
      if (selectedMinute === end.minute() && selectedMinute === startLimit.minute()) {
        disabledSeconds = range(0, startLimit.second()).concat(range(end.second() + 1, 60));
      } else if (selectedMinute === end.minute()) {
        disabledSeconds = range(end.second() + 1, 60);
      } else if (selectedMinute === startLimit.minute()) {
        disabledSeconds = range(0, startLimit.second());
      } else {
        disabledSeconds = [];
      }
    } else {
      if (selectedHour === end.hour()) {
        disabledSeconds = selectedMinute === end.minute() ? range(end.second() + 1, 60) : [];
      } else {
        disabledSeconds = selectedMinute === startLimit.minute() ? range(0, startLimit.second()) : [];
      }
    }

    return disabledSeconds;
  };

  TimeRangePicker.prototype.endDisabledHours = function () {
    var _a;

    var _b = this.props,
        value = _b.value,
        limit = _b.range;
    var startTime;

    if (value) {
      startTime = value.start;
    }

    var start = moment(startTime, this.format).hour();
    var endLimit = moment((_a = limit) === null || _a === void 0 ? void 0 : _a.end, this.format).hour() || 23;
    return startTime ? range(0, start).concat(range(endLimit + 1, 24)) : range(endLimit + 1, 24);
  };

  TimeRangePicker.prototype.endDisabledMinutes = function (selectedHour) {
    var _a;

    var _b = this.props,
        value = _b.value,
        limit = _b.range;
    var startTime;

    if (value) {
      startTime = value.start;
    }

    var start = moment(startTime, this.format);
    var endLimit = moment((_a = limit) === null || _a === void 0 ? void 0 : _a.end, this.format);
    var disabledMinutes = [];

    if (selectedHour === start.hour()) {
      if (selectedHour === endLimit.hour()) {
        disabledMinutes = range(0, start.minute()).concat(range(endLimit.minute() + 1, 60));
      } else {
        disabledMinutes = range(0, start.minute());
      }
    } else if (selectedHour === endLimit.hour()) {
      disabledMinutes = range(endLimit.minute() + 1, 60);
    } else {
      disabledMinutes = [];
    }

    return disabledMinutes;
  };

  TimeRangePicker.prototype.endDisabledSeconds = function (selectedHour, selectedMinute) {
    var _a;

    var _b = this.props,
        value = _b.value,
        limit = _b.range;
    var startTime;

    if (value) {
      startTime = value.start;
    }

    var start = moment(startTime, this.format);
    var endLimit = moment((_a = limit) === null || _a === void 0 ? void 0 : _a.end, this.format);
    var disabledSeconds = [];

    if (selectedHour !== start.hour() && selectedHour !== endLimit.hour()) {
      disabledSeconds = [];
    } else if (selectedHour === start.hour() && selectedHour === endLimit.hour()) {
      if (selectedMinute === start.minute() && selectedMinute === endLimit.minute()) {
        disabledSeconds = range(endLimit.second() + 1, 60).concat(range(0, start.second()));
      } else if (selectedMinute === start.minute()) {
        disabledSeconds = range(0, start.second());
      } else if (selectedMinute === endLimit.minute()) {
        disabledSeconds = range(endLimit.second() + 1, 60);
      } else {
        disabledSeconds = [];
      }
    } else {
      if (selectedHour === start.hour()) {
        disabledSeconds = selectedMinute === start.minute() ? range(0, start.second()) : [];
      } else {
        disabledSeconds = selectedMinute === endLimit.minute() ? range(endLimit.second() + 1, 60) : [];
      }
    }

    return disabledSeconds;
  };

  TimeRangePicker.prototype.render = function () {
    var _a = this.props,
        minuteStep = _a.minuteStep,
        hourStep = _a.hourStep,
        secondStep = _a.secondStep,
        hideDisabledOptions = _a.hideDisabledOptions,
        startDisabledHours = _a.startDisabledHours,
        startDisabledMinutes = _a.startDisabledMinutes,
        startDisabledSeconds = _a.startDisabledSeconds,
        endDisabledHours = _a.endDisabledHours,
        endDisabledMinutes = _a.endDisabledMinutes,
        endDisabledSeconds = _a.endDisabledSeconds,
        use12Hours = _a.use12Hours,
        style = _a.style,
        allowClear = _a.allowClear;
    var props = {
      format: this.format,
      minuteStep: minuteStep,
      hourStep: hourStep,
      secondStep: secondStep,
      hideDisabledOptions: hideDisabledOptions,
      use12Hours: use12Hours,
      allowClear: allowClear,
      style: style
    };
    var _b = this.props,
        value = _b.value,
        placeholder = _b.placeholder;
    var startTime;
    var endTime;

    if (value && value.start && value.end) {
      var start = value.start,
          end = value.end;
      this.startString = start;
      this.endString = end;
      startTime = moment(start, this.format);
      endTime = moment(end, this.format);
    }

    var placeholderStart = services.language.getText('components.TimeRangePicker.placeholder.start');
    var placeholderEnd = services.language.getText('components.TimeRangePicker.placeholder.end'); // 未设置 placeholder ，则使用默认

    if (placeholder && placeholder.length > 1) {
      placeholderStart = placeholder[0];
      placeholderEnd = placeholder[1];
    }

    return React.createElement("div", null, React.createElement(AntTimePicker, __assign({}, props, {
      value: startTime,
      onChange: this.onTimeChange.bind(this, 'start'),
      disabledHours: startDisabledHours || this.startDisabledHours,
      disabledMinutes: startDisabledMinutes || this.startDisabledMinutes,
      disabledSeconds: startDisabledSeconds || this.startDisabledSeconds,
      placeholder: placeholderStart
    })), React.createElement("span", {
      style: {
        margin: '0 10px'
      }
    }, "\u81F3"), React.createElement(AntTimePicker, __assign({}, props, {
      value: endTime,
      onChange: this.onTimeChange.bind(this, 'end'),
      disabledHours: endDisabledHours || this.endDisabledHours,
      disabledMinutes: endDisabledMinutes || this.endDisabledMinutes,
      disabledSeconds: endDisabledSeconds || this.endDisabledSeconds,
      placeholder: placeholderEnd
    })));
  };

  return TimeRangePicker;
}(Component);

export { TimeRangePicker };